import { TJobBilingual } from "apiTypes/jobs";

/**
 * Picks the localised value from the new bilingual field shape:
 * { ar: { value: "...", auto_generated: false }, en: { value: "..." }, ... }
 * Falls back to English when the requested locale has no value.
 */
export const pickLocale = (
  field: TJobBilingual | null | undefined,
  locale: string | undefined,
): string => {
  if (!field) return "";
  const loc = locale ?? "ar";
  return field[loc as keyof TJobBilingual]?.value
    ?? field.en?.value
    ?? field.ar?.value
    ?? "";
};
